import { __assign, __read, __spreadArray } from "tslib";
import React, { useCallback, useState } from 'react';
import cloneDeep from 'lodash.clonedeep';
import classNames from 'classnames';
import { Form } from '@tencent/tea-component/lib/form';
import { BuyIcon } from '@tencent/tcb-component/lib/buyicon';
import { BuyFormLink } from '@tencent/tcb-component/lib/buylink';
import i18n from '../i18n';
var t = i18n.t;
export function BuyDynamicFormItem(_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.addButton, addButton = _c === void 0 ? (React.createElement(React.Fragment, null,
        React.createElement(BuyIcon, { type: "new" }),
        React.createElement(BuyFormLink, null, t('添加')))) : _c, _d = _a.addButtonTips, addButtonTips = _d === void 0 ? null : _d, _e = _a.defaultValueItem, defaultValueItem = _e === void 0 ? {} : _e, value = _a.value, _f = _a.hideLabel, hideLabel = _f === void 0 ? false : _f, onChange = _a.onChange, itemRender = _a.itemRender, max = _a.max;
    // eslint-disable-next-line
    var ItemRender = useCallback(itemRender, [itemRender]);
    // 添加或删除的时候需要更新 randomKey
    var _g = __read(useState(Math.random()), 2), randomKey = _g[0], setRandomKey = _g[1];
    var hiddenAdd = max && max <= value.length;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tea-form__item buy-form-separate-item" },
            !hideLabel && (React.createElement("div", { className: "tea-form__label" },
                React.createElement("label", null, label))),
            value.map(function (oneValue, index) { return (React.createElement("div", { className: "tea-form__controls tea-form__controls--text", key: index + randomKey },
                React.createElement(ItemRender, __assign({}, oneValue, { setItemValue: function (itemKey, itemValue) {
                        var newValue = cloneDeep(value);
                        newValue[index][itemKey] = itemValue;
                        onChange(newValue);
                    }, setItemValues: function (newValues) {
                        var newValue = cloneDeep(value);
                        newValues.forEach(function (_a) {
                            var _b = __read(_a, 2), itemKey = _b[0], itemValue = _b[1];
                            newValue[index][itemKey] = itemValue;
                        });
                        onChange(newValue);
                    } })),
                React.createElement("a", { className: "buy-form__link buy-form-separate__link", onClick: function () {
                        var newValue = cloneDeep(value);
                        newValue.splice(index, 1);
                        onChange(newValue);
                        setRandomKey(Math.random());
                    } }, t('删除')))); })),
        !hiddenAdd && React.createElement(Form.Item, { className: classNames({
                'buy-form-hidden-label': hideLabel,
            }) },
            React.createElement("p", { className: "buy-item__new", onClick: function () {
                    onChange(__spreadArray(__spreadArray([], __read(cloneDeep(value))), [cloneDeep(defaultValueItem)]));
                    setRandomKey(Math.random());
                } }, addButton),
            addButtonTips)));
}
//# sourceMappingURL=BuyDynamicFormItem.js.map